import React from 'react';
import ElectronicHousingUnitAssemblyLinkForm from "./ElectronicHousingUnitAssemblyLinkForm";

export default function ElectronicHousingUnitAssemblyView() {
    return (
        <>
            <div className="relative container mx-auto shadow-2xl bg-white rounded-lg min-h-[46.4rem]">
                <ElectronicHousingUnitAssemblyLinkForm/>
            </div>
        </>
    );
}
